import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {Observable} from "rxjs/Observable";
import {GlobalProvider} from "../../providers/global/global";
import {RemarkService} from "../../store/remark/remark.service";

/**
 * Generated class for the SettingRemarksPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-remarks',
  templateUrl: 'setting-remarks.html',
})
export class SettingRemarksPage {

  public bemerkungsvorlagen: Observable<Array<any>>;
  public selectedTemplate: any = null;
  // public value: string = "";
  public editMode: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public globalProvider: GlobalProvider,
              public remarkService: RemarkService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingRemarksPage');
  }

  public new():void {
    this.selectedTemplate = {title: ""};
    this.editMode = true;
  }

  public edit(selectedTemplate):void {
    this.selectedTemplate = JSON.parse(JSON.stringify(selectedTemplate));
    this.editMode = true;
  }

  public back():void {
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public save():void {

    if(this.selectedTemplate._id){
      //update
      this.remarkService.set(this.selectedTemplate, false);
      // this.dataProvider.updateDocument(this.selectedTemplate);
    }
    else{
      //new
      this.selectedTemplate.docType = 'remark';
      this.selectedTemplate.docName = 'Bemerkung';
      this.remarkService.add(this.selectedTemplate, false);
      // this.dataProvider.createDocumentWithoutInit(this.selectedTemplate);
    }
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public delete():void {
    this.remarkService.remove(this.selectedTemplate, false);
    // this.dataProvider.hardDeleteDocument(this.selectedTemplate);
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public setCategoryName($event): void {
    this.selectedTemplate.category = $event;
  }


}



// WEBPACK FOOTER //
// ./src/pages/setting-remarks/setting-remarks.ts